import { themeSlice } from './Theme.slice';

export const { setTheme } = themeSlice.actions;
